import React, { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import Swal from "sweetalert2";

const BedDetails = () => {
  const [formData, setFormData] = useState({ l1: [], wards: [], page_no: 0 });
  const [showModal, setShowModal] = useState(false);
  const [modalState, setModalState] = useState({
    currentBed: null,
    patientUhid: "",
    patientName: "",
    patientId: "",
    currentAllocationStart: null,
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedTargetBed, setSelectedTargetBed] = useState(null);
  const [transferLoading, setTransferLoading] = useState(false);
  const [loadingIpd, setLoadingIpd] = useState(true);

  const getBedKey = (b) => String(b?.bed_id ?? b?.id ?? '');
  const selectedBedObj = searchResults.find(b => getBedKey(b) === selectedTargetBed);

  const initData = async () => {
    try {
      const fd = new FormData();
      fd.append("par_by", "1");
      const resp = await axios.post(AppConst.BASE_URL + AppConst.getBedListUrl1, fd);
      if (resp.data?.status) setFormData((p) => ({ ...p, wards: resp.data.records || [] }));
    } catch (e) {
      console.error("initData getBedListUrl1 error", e);
    }
  };

  const initData2 = async () => {
    setLoadingIpd(true);
    try {
      const fd = new FormData();
      fd.append("page_no", "0");
      fd.append("search_key", "");
      const resp = await axios.post(AppConst.BASE_URL + AppConst.getIpdListUrl, fd);
      console.debug("initData2 response:", resp?.data);
      if (resp.data?.status && Array.isArray(resp.data.records)) {
        setFormData((p) => ({ ...p, l1: resp.data.records || [] }));
      } else {
        setFormData((p) => ({ ...p, l1: [] }));
      }
    } catch (e) {
      console.error("initData2 getIpdListUrl error", e);
      setFormData((p) => ({ ...p, l1: [] }));
    } finally {
      setLoadingIpd(false);
    }
  };

  useEffect(() => {
    const stored = sessionStorage.getItem("ldata");
    if (stored) { initData(); initData2(); }
    // eslint-disable-next-line
  }, []);

  const nameCandidates = (rec) =>
    rec?.lab_reg_name || rec?.ipd_patient_name || rec?.patient_name || rec?.name || rec?.fname || rec?.opd_patient_name || "";

  const findIpdByUserId = (userId) => {
    if (!userId) return null;
    const uid = String(userId).trim();
    const list = Array.isArray(formData.l1) ? formData.l1 : [];
    const idFields = (rec) => [
      rec?.ipd_id, rec?.id, rec?.user_id, rec?.lab_reg_id,
      rec?.opd_id, rec?.patient_id, rec?.ipd_patient_id, rec?.reg_id,
      rec?.patient_uid, rec?.uid
    ].filter(x => x !== undefined && x !== null).map(x => String(x).trim());
    const exact = list.find(rec => idFields(rec).some(id => id === uid));
    if (exact) return exact;
    const numeric = Number(uid);
    if (!isNaN(numeric)) {
      const numMatch = list.find(rec => idFields(rec).some(id => !isNaN(Number(id)) && Number(id) === numeric));
      if (numMatch) return numMatch;
    }
    const fuzzy = list.find(rec => {
      const recUhid = (rec?.ipd_uhid || rec?.uhid || rec?.lab_reg_uhid || '').toString().trim();
      const phone = (rec?.ipd_patient_mobile || rec?.mobile || rec?.patient_mobile || rec?.phone || '').toString().trim();
      return recUhid === uid || phone === uid;
    });
    return fuzzy || null;
  };

  const displayUhidForRecord = (rec) => {
    if (!rec) return '';
    return rec.lab_reg_uhid || rec.ipd_uhid || rec.opd_uhid_move || rec.uhid || rec.uhid_no || rec.uhidNumber || '';
  };

  const getPatientInfoForBed = (bed) => {
    const rec = findIpdByUserId(bed.user_id || bed.user || bed.ipd_id || bed.patient_id) || {};
    const name = rec.ipd_patient_name || rec.patient_name || rec.lab_reg_name || rec.name || rec.fname || rec.full_name || rec.opd_patient_name || bed.ipd_patient_name || bed.patient_name || '';
    const uhid = displayUhidForRecord(rec) || displayUhidForRecord(bed) || '';
    return { name: name || '', uhid: uhid || '' };
  };

  const uhidCandidates = (rec) =>
    rec?.lab_reg_uhid || rec?.ipd_uhid || rec?.opd_uhid_move || rec?.uhid || rec?.uhid_no || rec?.uhidNumber || "";

  const idCandidates = (rec) =>
    rec?.ipd_id || rec?.user_id || rec?.id || rec?.lab_reg_id || "";

  const isBedFree = (b) => {
    if (!b) return false;
    const s = (b.status !== undefined && b.status !== null) ? String(b.status).toLowerCase() : "";
    if (["0", "free", "available", "false", ""].includes(s)) return true;
    if (b.is_free === true || b.is_free === "1" || b.is_free === 1) return true;
    if (b.user_id === "0" || b.user_id === 0 || b.user_id === null || b.user_id === "") return true;
    return false;
  };

  const flattenWardsToBeds = (wards) => {
    const out = [];
    (wards || []).forEach((w) => {
      const catName = w.cat_name || w.ward_name || "";
      (w.beds || []).forEach((b) => out.push({ ...b, cat_name: catName }));
    });
    return out;
  };

  const populateAvailableBeds = async (q) => {
    if (AppConst.searchBedsUrl) {
      try {
        const fd = new FormData();
        fd.append("search_key", q || "");
        const resp = await axios.post(AppConst.BASE_URL + AppConst.searchBedsUrl, fd);
        if (resp.data?.status) { setSearchResults((resp.data.records || []).filter((b) => isBedFree(b))); return; }
      } catch (e) { console.warn("searchBedsUrl failed", e); }
    }
    if (AppConst.getBedListUrl) {
      try {
        const fd = new FormData();
        fd.append("page_no", "none");
        fd.append("bed_user", "1");
        if (q) fd.append("search_key", q);
        const resp = await axios.post(AppConst.BASE_URL + AppConst.getBedListUrl, fd);
        if (resp.data?.status) {
          const recs = (resp.data.records || []).filter((b) => isBedFree(b));
          setSearchResults(q ? recs.filter(r => String(r.bed_name || "").toLowerCase().includes(q.toLowerCase()) || String(r.cat_name || r.ward_name || "").toLowerCase().includes(q.toLowerCase())) : recs);
          return;
        }
      } catch (e) { console.warn("getBedListUrl fallback failed", e); }
    }
    const available = flattenWardsToBeds(formData.wards).filter((b) => isBedFree(b));
    setSearchResults(q ? available.filter(r => String(r.bed_name || "").toLowerCase().includes(q.toLowerCase()) || String(r.cat_name || "").toLowerCase().includes(q.toLowerCase())) : available);
  };

  const openTransferModal = async (bedItem) => {
    const source = bedItem || {};
    const pidCandidates = [source.user_id, source.ipd_id, source.patient_id, source.user || source.id].filter(Boolean);
    let foundIpd = null;
    if (pidCandidates.length && formData.l1 && formData.l1.length) {
      foundIpd = formData.l1.find(rec => pidCandidates.some(p => String(rec.ipd_id) === String(p) || String(rec.user_id) === String(p) || String(rec.id) === String(p)));
    }
    let fetchedIpd = null;
    if (!foundIpd && AppConst.getIpdByIdUrl && pidCandidates.length) {
      try {
        const fd = new FormData();
        fd.append("id", pidCandidates[0] + "");
        const resp = await axios.post(AppConst.BASE_URL + AppConst.getIpdByIdUrl, fd);
        if (resp.data?.status) fetchedIpd = resp.data.record;
      } catch (e) { console.warn("getIpdByIdUrl failed", e); }
    }
    let sess = null;
    try { sess = JSON.parse(sessionStorage.getItem("ipd_dt") || "null"); } catch (e) { sess = null; }
    const ipdRec = foundIpd || fetchedIpd || sess || null;
    const patientName = nameCandidates(ipdRec) || nameCandidates(source) || "";
    const patientUhid = uhidCandidates(ipdRec) || uhidCandidates(source) || (sess && (sess.ipd_uhid || sess.lab_reg_uhid || sess.opd_uhid_move)) || "";
    const patientId = idCandidates(ipdRec) || pidCandidates[0] || "";
    const allocationCandidates = [
      ipdRec && (ipdRec.bed_allocated_at || ipdRec.allocated_at || ipdRec.ipd_admit_date || ipdRec.created_at || ipdRec.admit_datetime),
      source.bed_datetime || source.allocated_at || source.created_at || source.assigned_at,
      sess && (sess.bed_datetime || sess.created_at)
    ].filter(Boolean);
    const allocationStart = allocationCandidates.length ? allocationCandidates[0] : null;
    setModalState({ currentBed: source, patientName, patientUhid, patientId, currentAllocationStart: allocationStart });
    await populateAvailableBeds("");
    setSelectedTargetBed(null);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalState({ currentBed: null, patientUhid: "", patientName: "", patientId: "", currentAllocationStart: null });
    setSearchResults([]);
    setSelectedTargetBed(null);
  };

  const handleSelectTargetBed = (b) => {
    if (!isBedFree(b)) { Swal.fire("Bed not free", "Please pick an available bed.", "warning"); return; }
    setSelectedTargetBed(getBedKey(b));
  };

  const computeMinutesOccupied = (start) => {
    if (!start) return 0;
    const dt = new Date(start);
    if (isNaN(dt.getTime())) return 0;
    return Math.floor((new Date() - dt) / (1000 * 60));
  };

  const formatDuration = (minutes) => {
    if (!minutes) return "—";
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    if (h > 0) return `${h}h ${m}m`;
    return `${m}m`;
  };

  const doTransfer = async (targetBed) => {
    if (!modalState.currentBed) return Swal.fire("No source", "No source bed selected", "error");
    if (!modalState.patientId) return Swal.fire("No patient id", "Cannot find patient id for the source bed.", "error");
    if (!targetBed) return Swal.fire("No target", "Please select a target bed", "error");
    if (!AppConst.transferBedUrl) return Swal.fire("Config", "Please set AppConst.transferBedUrl.", "error");
    const minutes = computeMinutesOccupied(modalState.currentAllocationStart);
    const fd = new FormData();
    fd.append("patient_id", modalState.patientId + "");
    fd.append("uhid", modalState.patientUhid + "");
    fd.append("source_bed_id", modalState.currentBed.bed_id || modalState.currentBed.id || "");
    fd.append("target_bed_id", targetBed.bed_id || targetBed.id || "");
    fd.append("minutes_occupied", String(minutes));
    fd.append("by_user", "1");
    try {
      const confirm = await Swal.fire({
        title: "Confirm Transfer",
        html: `<p>From <b>${modalState.currentBed?.bed_name}</b> → <b>${targetBed?.bed_name}</b></p>`,
        showCancelButton: true,
        confirmButtonText: "Transfer",
        confirmButtonColor: "#405189",
      });
      if (!confirm.isConfirmed) return;
      setTransferLoading(true);
      const resp = await axios.post(AppConst.BASE_URL + AppConst.transferBedUrl, fd);
      if (resp.data?.status) {
        await initData();
        await initData2();
        closeModal();
        Swal.fire("Done", resp.data.message || "Transfer successful", "success");
      } else {
        Swal.fire("Failed", resp.data?.message || "Server rejected transfer", "error");
      }
    } catch (e) {
      console.error("Transfer API error:", e);
      Swal.fire("Error", "Network/server error", "error");
    } finally {
      setTransferLoading(false);
    }
  };

  // Count beds
  const allBeds = flattenWardsToBeds(formData.wards);
  const totalBeds = allBeds.length;
  const freeBeds = allBeds.filter(b => isBedFree(b)).length;
  const occupiedBeds = totalBeds - freeBeds;

  return (
    <div className="page-content">
      <div className="container-fluid">

        {/* Page Header */}
        <div className="d-flex align-items-center justify-content-between mb-3">
          <h4 style={{ fontWeight: 700, color: '#405189', margin: 0 }}>Bed Management</h4>
          <div className="d-flex gap-3">
            <div className="text-center">
              <div style={{ fontSize: 22, fontWeight: 700, color: '#1e293b' }}>{totalBeds}</div>
              <div style={{ fontSize: 12, color: '#7c8494' }}>Total</div>
            </div>
            <div className="text-center">
              <div style={{ fontSize: 22, fontWeight: 700, color: '#0ab39c' }}>{freeBeds}</div>
              <div style={{ fontSize: 12, color: '#7c8494' }}>Available</div>
            </div>
            <div className="text-center">
              <div style={{ fontSize: 22, fontWeight: 700, color: '#f06548' }}>{occupiedBeds}</div>
              <div style={{ fontSize: 12, color: '#7c8494' }}>Occupied</div>
            </div>
          </div>
        </div>

        {/* Legend */}
        <div className="d-flex gap-3 mb-3" style={{ fontSize: 13 }}>
          <span className="d-flex align-items-center gap-1">
            <span style={{ width: 12, height: 12, borderRadius: 3, background: '#0ab39c', display: 'inline-block' }} /> Available
          </span>
          <span className="d-flex align-items-center gap-1">
            <span style={{ width: 12, height: 12, borderRadius: 3, background: '#f06548', display: 'inline-block' }} /> Occupied
          </span>
        </div>

        {/* Ward Sections */}
        {(formData.wards || []).map((w, wi) => (
          (w.beds || []).length > 0 ? (
            <div className="ward-section" key={wi}>

              {/* Ward Header */}
              <div className="ward-header">
                <i className="ri-hotel-bed-line me-2" />{w.cat_name}
                <span style={{ fontWeight: 400, fontSize: 13, color: '#7c8494', marginLeft: 10 }}>
                  ({(w.beds || []).filter(b => isBedFree(b)).length} available / {(w.beds || []).length} total)
                </span>
              </div>

              {/* Bed Cards */}
              <div className="row g-3">
                {(w.beds || []).map((b, bi) => {
                  const free = isBedFree(b);
                  const info = !free ? getPatientInfoForBed(b) : null;

                  return (
                    <div className="col-xl-3 col-lg-4 col-md-6" key={bi}>
                      <div className={`bed-card ${free ? 'bed-free' : 'bed-occupied'}`}>
                        <div style={{ padding: '16px 18px 12px' }}>

                          {/* Patient info (occupied only) */}
                          {!free && info && (
                            <div className="bed-patient-info">
                              <div className="bed-patient-name">{info.name || '—'}</div>
                              {info.uhid && <div className="bed-patient-uhid">UHID: {info.uhid}</div>}
                            </div>
                          )}

                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <div className="bed-name">{b.bed_name}</div>
                              <div className="bed-price">Price: <strong>₹{b.bed_price}</strong></div>
                            </div>
                            <div className={`bed-icon-circle ${free ? 'free' : 'occupied'}`}>
                              <i className="bx bx-bed" />
                            </div>
                          </div>

                          {/* Status tag */}
                          <div className="mt-2">
                            <span className={`bed-status-tag ${free ? 'free' : 'occupied'}`}>
                              {free ? 'Available' : 'Occupied'}
                            </span>
                          </div>
                        </div>

                        {/* Transfer button (occupied only) */}
                        {!free && (
                          <button className="bed-transfer-btn" onClick={() => openTransferModal(b)}>
                            <i className="ri-arrow-left-right-line me-1" />Transfer Bed
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null
        ))}

        {/* Empty state */}
        {(formData.wards || []).length === 0 && (
          <div className="text-center text-muted py-5" style={{ fontSize: 15 }}>
            <i className="ri-hotel-bed-line" style={{ fontSize: 40, opacity: 0.3 }} /><br />
            No wards or beds found
          </div>
        )}
      </div>

      {/* ══════════ Transfer Modal ══════════ */}
      {showModal && (
        <div className="modal show" style={{ display: "block", background: "rgba(0,0,0,0.5)", zIndex: 9999 }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header" style={{ background: '#f8f9fb', borderBottom: '1px solid #e5e8ef' }}>
                <h5 className="modal-title" style={{ fontWeight: 700, color: '#405189' }}>
                  <i className="ri-arrow-left-right-line me-2" />Transfer Bed
                </h5>
                <button className="btn-close" onClick={closeModal} />
              </div>

              <div className="modal-body" style={{ padding: 22 }}>

                {/* Current Info */}
                <div style={{ background: '#f0f3f8', borderRadius: 8, padding: '14px 18px', marginBottom: 18 }}>
                  <div className="row g-2">
                    <div className="col-md-4">
                      <div style={{ fontSize: 12, color: '#7c8494', fontWeight: 600, marginBottom: 2 }}>CURRENT BED</div>
                      <div style={{ fontSize: 16, fontWeight: 700, color: '#1e293b' }}>{modalState.currentBed?.bed_name || '—'}</div>
                    </div>
                    <div className="col-md-4">
                      <div style={{ fontSize: 12, color: '#7c8494', fontWeight: 600, marginBottom: 2 }}>PATIENT</div>
                      <div style={{ fontSize: 14, fontWeight: 600, color: '#1e293b' }}>{modalState.patientName || '—'}</div>
                      <div style={{ fontSize: 12, color: '#7c8494' }}>UHID: {modalState.patientUhid || '—'}</div>
                    </div>
                    <div className="col-md-4">
                      <div style={{ fontSize: 12, color: '#7c8494', fontWeight: 600, marginBottom: 2 }}>DURATION</div>
                      <div style={{ fontSize: 14, fontWeight: 600, color: '#1e293b' }}>{formatDuration(computeMinutesOccupied(modalState.currentAllocationStart))}</div>
                    </div>
                  </div>
                </div>

                {/* Search */}
                <label className="form-label">Select New Bed</label>
                <input
                  className="form-control mb-3"
                  value={searchQuery}
                  onChange={(e) => { setSearchQuery(e.target.value); populateAvailableBeds(e.target.value); }}
                  placeholder="Search by bed name or ward..."
                />

                {/* Available beds list */}
                <div style={{ maxHeight: 300, overflowY: "auto" }}>
                  {searchResults.length ? searchResults.map((b, i) => {
                    const sel = selectedTargetBed === getBedKey(b);
                    return (
                      <div
                        key={i}
                        className={`bed-pick-item ${sel ? 'selected' : ''}`}
                        onClick={() => handleSelectTargetBed(b)}
                      >
                        <div>
                          <div className="pick-name">{b.bed_name}</div>
                          <div className="pick-ward">{b.cat_name || b.ward_name || ""}</div>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          {b.bed_price && <span style={{ fontSize: 13, fontWeight: 600, color: '#64748b' }}>₹{b.bed_price}</span>}
                          <span className="bed-status-tag free">Available</span>
                          {sel && <i className="ri-checkbox-circle-fill" style={{ fontSize: 20, color: '#405189' }} />}
                        </div>
                      </div>
                    );
                  }) : (
                    <div className="text-center text-muted py-3" style={{ fontSize: 14 }}>
                      No available beds found
                    </div>
                  )}
                </div>
              </div>

              <div className="modal-footer" style={{ borderTop: '1px solid #e5e8ef', padding: '14px 22px' }}>
                <button className="btn btn-secondary" onClick={closeModal} style={{ borderRadius: 6 }}>Cancel</button>
                <button
                  className="btn btn-primary"
                  disabled={!selectedBedObj || transferLoading}
                  onClick={() => doTransfer(selectedBedObj)}
                  style={{ borderRadius: 6 }}
                >
                  {transferLoading ? (
                    <><span className="spinner-border spinner-border-sm me-1" />Transferring...</>
                  ) : (
                    <><i className="ri-arrow-left-right-line me-1" />Transfer</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BedDetails;